module.exports = __webpack_public_path__ + "static/img/xi_12.1092562.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/xi_12.jpg
// module id = rxnq
// module chunks = 1